import {Injectable} from '@angular/core';
import {Http} from '@angular/http';
import {ParentService} from '../../pages/A2-utils/ParentClass/ParentService';
import {map} from 'rxjs/operators';
import {IReasonDelay} from '../interfaces/reasons-delay.interface';
import {Observable} from 'rxjs/Observable';
import {constant} from '../../app.constants';

@Injectable()
export class ReasonsDelayService extends ParentService {
  constructor(
    private _http: Http
  ) {
    super();
  }

  /**
   * @type get
   * @description list payor
   */
  getReasons(): Observable<IReasonDelay[]> {
    return this._http.get(`${constant.URL_REASONS_DELAY}`, this.getHeader()).pipe(
      map((response: any) => response.json() as IReasonDelay[]),
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/core/services/reasons-delay.service.ts